import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-adapter-integration-mappings',
  templateUrl: './adapter-integration-mappings.component.html',
  styleUrls: ['./adapter-integration-mappings.component.scss']
})
export class AdapterIntegrationMappingsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
